import { useState } from "react"
import DeleteButton from "../ui/components/DeleteButton"
import EditButton from "../ui/components/EditButton"
import DinamicButton from "../ui/components/DinamicButton"
import Modal from "../ui/Modal"
import { FaImage, FaFile, FaEye, FaTrash, FaUpload, FaDownload, FaSpinner } from "react-icons/fa"
import DinamicBoxButton from "../ui/components/DinamicBoxButton"
import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { toast } from "react-toastify"
import IdButton from "../ui/components/IdButton"
import CopyToClipBoard from "../../utils/CopyToClipBoard"

const getValueFromPath = (object, path) => {
  if (!object || !path) return undefined
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), object)
}

const ItemRowRegistroCompraStakeholders = ({headersTableActive, headers, purchase, openEditPurchase, DeletePurchase, setter}) => {

  const [openImagesModal, setOpenImagesModal] = useState(false)
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false)
  const [uploadingFile, setUploadingFile] = useState(false)

  // Funciones para manejo de archivos
  const uploadFile = async ({file, field}) => {
    try {
      setUploadingFile(true)

      // Obtener los IDs existentes del campo (images o documents)
      const existingIds = purchase[field]?.map((item) => item.id) || []
      
      // Crear FormData para subir el archivo
      const formData = new FormData()
      formData.append('file', file)

      // Subir archivo a comprasImagenes
      const responseFile = await axios.post(`${BACKEND}/api/comprasImagenes`, formData)
      const fileCreatedId = responseFile.data.doc.id

      const dataToSend = [...existingIds, fileCreatedId]
      console.log(dataToSend)

      // Actualizar el array de IDs en comprasStakeholders
      const response = await axios.put(`${BACKEND}/api/comprasStakeholders/${purchase.id}`, {
        [field]: [...existingIds, fileCreatedId]
      })

      const docUpdated = response.data.doc

      // Actualizar el estado local con el nuevo registro
      setter(prev => prev.map(item => 
        item.id === purchase.id ? docUpdated : item
      ))
            
      // Recargar los datos de la compra para mostrar el nuevo archivo
      toast.success('Archivo subido exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo archivo')
    } finally {
      setUploadingFile(false)
    }
  }

  const deleteFile = async ({id, field}) => {
    try {
      // Obtener los IDs existentes del campo (images o documents)
      const existingIds = purchase[field]?.map((item) => item.id) || []
      
      // Filtrar el ID que se va a eliminar
      const updatedIds = existingIds.filter(fileId => fileId !== id)
      
      // 1. Eliminar el archivo de la colección comprasImagenes
      await axios.delete(`${BACKEND}/api/comprasImagenes/${id}`)
      
      // 2. Actualizar el array de IDs en comprasStakeholders
      const responsePurchase = await axios.put(`${BACKEND}/api/comprasStakeholders/${purchase.id}`, {
        [field]: updatedIds
      })
      
      const docUpdated = responsePurchase.data.doc
      
      // Actualizar el estado local con el registro actualizado
      setter(prev => prev.map(item => 
        item.id === purchase.id ? docUpdated : item
      ))
      
      toast.success('Archivo eliminado exitosamente')
      
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando archivo')
    }
  }

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank')
  }

  return (
    <tr key={purchase.id} className="text-xs py-3 w-full text-gray-900 hover:bg-gray-100 transition-all duration-100">
      
      <Modal // Imágenes
        activeModal={openImagesModal}
        onClose={() => { setOpenImagesModal(false) }}
        title="Imágenes de la compra"
        className="max-w-4xl"
        centered
      >
        <div className="flex flex-col gap-4">
          {/* Sección de subida de imágenes */}
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
            <input
              type="file"
              id="image-upload"
              accept="image/*"
              multiple
              className="hidden"
              disabled={uploadingFile}
              onChange={(e) => {
                const files = Array.from(e.target.files)
                files.forEach(file => uploadFile({file, field: "images"}))
              }}
            />
            <label htmlFor="image-upload" className={`cursor-pointer ${uploadingFile ? 'opacity-50' : ''}`}>
              {uploadingFile ? (
                <FaSpinner className="mx-auto text-sm text-gray-400 mb-2 animate-spin" />
            ) : (
                <FaUpload className="mx-auto text-sm text-gray-400 mb-2" />
              )}
              <p className="text-gray-600 text-sm">
                {uploadingFile ? 'Subiendo...' : 'Haz clic para subir imágenes'}
              </p>
              <p className="text-xs mt-2 text-gray-400">PNG, JPG, JPEG hasta 5MB</p>
            </label>
          </div>

          {/* Lista de imágenes */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {purchase.images && purchase.images.length > 0 ? (
              purchase.images.map((image, index) => (
                <div key={index} className="border rounded-lg p-2 bg-white">
                  <div className="relative">
                    <img
                      src={image.url}
                      alt={`Imagen ${index + 1}`}
                      className="w-full h-32 object-cover rounded cursor-pointer"
                      onClick={() => openFileInNewTab(image.url)}
                    />
                    <button
                      onClick={() => deleteFile({id: image.id, field: "images"})}
                      className="absolute top-1 right-1 text-red-500 hover:text-red-700"
                      title="Eliminar imagen"
                    >
                      <FaTrash className="text-sm" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-xs text-center text-gray-500 py-8">
                No hay imágenes disponibles
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal // Documentos
        activeModal={openDocumentsModal}
        onClose={() => { setOpenDocumentsModal(false) }}
        title="Documentos de la compra"
        className="max-w-4xl"
        centered
      >
        <div className="flex flex-col gap-4">
          {/* Sección de subida de documentos */}
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
            <input
              type="file"
              id="document-upload"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
              multiple
              className="hidden"
              disabled={uploadingFile}
              onChange={(e) => {
                const files = Array.from(e.target.files)
                files.forEach(file => uploadFile({file, field: "documents"}))
              }}
            />
            <label htmlFor="document-upload" className={`cursor-pointer ${uploadingFile ? 'opacity-50' : ''}`}>
              {uploadingFile ? (
                <FaSpinner className="mx-auto text-sm text-gray-400 mb-2 animate-spin" />
              ) : (
                <FaUpload className="mx-auto text-sm text-gray-400 mb-2" />
              )}
              <p className="text-gray-600 text-sm">
                {uploadingFile ? 'Subiendo...' : 'Haz clic para subir documentos'}
              </p>
              <p className="text-xs mt-2 text-gray-400">PDF, DOC, XLS hasta 10MB</p>
            </label>
          </div>

          {/* Lista de documentos */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {purchase.documents && purchase.documents.length > 0 ? (
              purchase.documents.map((document, index) => (
                <div key={index} className="border rounded-lg p-2 bg-white">
                  <div className="relative">
                    <div 
                      className="w-full h-32 bg-gray-100 rounded flex flex-col items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors"
                      onClick={() => openFileInNewTab(document.url)}
                    > 
                      <FaFile className="text-4xl text-gray-400 mb-2" />
                      <p className="text-xs text-gray-600 text-center px-2 truncate w-full">
                        {document.filename || `Documento ${index + 1}`}
                      </p>
                      {document.size && (
                        <p className="text-xs text-gray-400 mt-1">
                          {(document.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                      )}
                    </div>
                    <button
                      onClick={() => deleteFile({id: document.id, field: "documents"})}
                      className="absolute top-1 right-1 text-red-500 hover:text-red-700"
                      title="Eliminar documento"
                    >
                      <FaTrash className="text-sm" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500 py-8 text-xs">
                No hay documentos disponibles
              </div>
            )}
          </div>
        </div>
      </Modal>

      {headers.map((header, idx) => (
        headersTableActive.find((e) => e.id === header.id)?.show && (

          header.value === "actions" ? (
            <td key={`actions-${idx}`} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center">
                <EditButton
                  content="Editar registro"
                  action={() => openEditPurchase(purchase)}
                />
                <IdButton
                  content={purchase.id}
                  action={() => CopyToClipBoard(purchase.id)}
                />
                {/* <DeleteButton
                  content="Eliminar registro"
                  action={() => DeletePurchase(purchase.id)}
                /> */}
              </div>
            </td>
          ) : header.value === "images" ? (
            <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center items-center">
                <DinamicBoxButton
                  content="Ver imágenes"
                  icon={<FaImage/>}
                  action={() => setOpenImagesModal(true)}
                  backgroundColor="#3b82f6"
                  hoverBackgroundColor="#2563eb"
                  size="sm"
                />
                {purchase.images?.length > 0 && (
                  <span className="text-xs text-gray-500">
                    {purchase.images?.length}
                  </span>
                )}
              </div>
            </td>
          ) : header.value === "docuemnt" ? (
            <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center items-center">
                <DinamicBoxButton
                  content="Ver documentos"
                  icon={<FaFile/>}
                  action={() => setOpenDocumentsModal(true)}
                  backgroundColor="#3b82f6"
                  hoverBackgroundColor="#2563eb"
                  size="sm"
                />
                {purchase.documents?.length > 0 && (
                  <span className="text-xs text-gray-500">
                    {purchase.documents?.length}
                  </span>
                )}
              </div>
            </td>
          ) : (
            (() => {
              const rawValue = getValueFromPath(purchase, header.value)
              const value = header.formatter ? header.formatter(rawValue, purchase) : (rawValue ?? "-")
              return (
                <td key={idx} title={value} className={`px-4 py-1 max-w-[24rem] border border-gray-300 truncate text-center z-10 ${value && value !== "-" ? "text-gray-900" : "text-gray-200"}`}>
                  {value}
                </td>
              )
            })()
          ))
        )
      )}
    </tr>
  )
}

export default ItemRowRegistroCompraStakeholders